import CryptoJS from "crypto-js";

let secret = "YpAvD7m1s4v8IXvpB0aQ435OP1FV8b";
let ask = false;
let callbacklist = [];
function decrypt(message, secret) {
  const clear_text = CryptoJS.AES.decrypt(message, secret).toString(
    CryptoJS.enc.Utf8
  );
  return JSON.parse(clear_text);
}

function getsecret(callback) {
  callback();
  /*
    if(!ask){
        //console.log("Secret not set, setting")
        ask = true
        callbacklist = [callback]
        callbacklist.push(callback)
        //console.log("Waiting ", callbacklist.length, callbacklist)
        doGet("/login/session", {}, (data) => {
            //console.log("Secret set")
            ask=false
            secret = data.id
            callbacklist.forEach((one_callback)=>{
                one_callback()
            })
        }).then()
    }else{
        //console.log("Secret already asked")
        callbacklist.push(callback)
        //console.log("Waiting ", callbacklist.length, callbacklist)
    }

     */
}

export { ask, decrypt, getsecret, secret };
